export default __webpack_public_path__ + "static/media/sejan-web-resume_2.aec43756.pdf";